module.exports = __webpack_public_path__ + "static/media/gas.76a56e24.png";